import React, { useEffect, useState } from 'react';
import { globals } from '../../misc/globals';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';

import './GeneralButtonWithText.css'

const GeneralButtonWithText = (props: UIProperties<GeneralButtonWithTextConfig>) => {
	const [isOver, setIsOver] = useState(false);
	useEffect(() => {

	}, [isOver])

	return (
		<div style={{
			position: 'absolute',
			top: props.parameters.top,
			left: props.parameters.left,
			width: props.parameters.srcIdle && props.parameters.srcHighlight ? props.parameters.width : 'auto',
			...props.parameters.customRootCss
		}}>
			<button tabIndex={props.parameters.isNotTabbable ? -1 : 0} id={props.parameters.id} aria-label={props.parameters.ariaLbl ?? props.parameters.text} className="pointer" style={{
				position: 'relative',
				background: 'transparent',
				pointerEvents: 'all'
			}} onMouseEnter={() => {
				var rollOverAudio = document.getElementById('button-rollover');

				if(!globals.isMuted) {
					(rollOverAudio as any).play();

				}
			}} onMouseDown={() => {
				setIsOver(true);
			}} onMouseUp={() => {
				setIsOver(false);
			}} onMouseOut={() => {
				setIsOver(false);
			}} onClick={() => {
				var clickAudio = document.getElementById('button-click');
				
				if(!globals.isMuted) {
					(clickAudio as any).play()
				}
				if(props.parameters.onClicked) {
					props.parameters.onClicked();
				}
			}}>
				<img style={{...props.parameters.customImgStyle,
					pointerEvents: 'none',
					position: 'relative'
				}} src={props.parameters.srcIdle ? props.parameters.srcIdle :"./assets/images/general/buttons/button_main.png"} />
				
				{isOver || props.parameters.shouldLeaveOn ? (<img style={{...props.parameters.customImgStyle,
					position: 'absolute',
					top: '0',
					left: '0',
					height: '100%',
					pointerEvents: 'none'
				}} src={props.parameters.srcHighlight ? props.parameters.srcHighlight : "./assets/images/general/buttons/button_hover.png"}  />) : (<div></div>)}

				<p className="title-font" style={{
					position: 'absolute',
					margin: '0',
					left: '50%',
					top: '50%',
					transform: 'translate(-50%, -50%)',
					width: '100%',
					color: 'white'
				}}>{props.parameters.text}</p>
			</button>
		</div>
	);

};

export interface GeneralButtonWithTextConfig extends BaseConfig{
	top: string;
	left: string;
	srcIdle?: string;
	ariaLbl?: string;
	id?: string;
	isNotTabbable?: boolean;
	customRootCss?: any;
	srcHighlight?: string;
	text: string;
	width: string;
	shouldLeaveOn?: boolean;
	customImgStyle?: any;
	onClicked: () => void;
}

export default GeneralButtonWithText;